import { useEffect } from "react";
import "./TermsConditionsStyle.css"; // Reusing the same styles

const ReturnRefundPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="legal-page-container">
      <h1 className="legal-heading">Return & Refund Policy</h1>
      <div className="legal-content">
        <div className="legal-section">
          <h2>1. Return Eligibility</h2>
          <p>
            We want you to be completely satisfied with your Minute watch purchase. 
            Items may be returned within 30 days of delivery if they meet the following criteria:
          </p>
          <ul>
            <li>Item is in original condition with all original packaging</li>
            <li>All accessories, manuals, and warranty cards are included</li>
            <li>Watch shows no signs of wear or damage</li>
            <li>Original tags and protective films are intact</li>
            <li>Return is initiated within 30 days of delivery date</li>
          </ul>
          <div className="policy-highlight">
            <p>Custom or personalized watches cannot be returned unless defective.</p>
          </div>
        </div>

        <div className="legal-section">
          <h2>2. Non-Returnable Items</h2>
          <p>
            The following items cannot be returned:
          </p>
          <ul>
            <li>Watches with custom engraving or personalization</li>
            <li>Items damaged by misuse, accidents, or normal wear</li>
            <li>Watches with missing parts or accessories</li>
            <li>Items returned after the 30-day return window</li>
            <li>Watches purchased with special promotional discounts (50% off)</li>
          </ul>
        </div>

        <div className="legal-section">
          <h2>3. Return Process</h2>
          <p>
            To initiate a return, please follow these steps:
          </p>
          <ol style={{paddingLeft: "1.5rem"}}>
            <li><strong>Contact Us:</strong> Email returns@minute.com with your order number</li>
            <li><strong>Return Authorization:</strong> We'll provide a Return Authorization Number (RAN)</li>
            <li><strong>Package Item:</strong> Securely package the watch with all original materials</li>
            <li><strong>Ship Back:</strong> Use the prepaid return label (for eligible regions)</li>
            <li><strong>Processing:</strong> Refund processed within 5-7 business days after receipt</li>
          </ol>
        </div>

        <div className="legal-section">
          <h2>4. Return Shipping</h2>
          
          <h3>Free Return Shipping</h3>
          <p>We provide free return shipping for:</p>
          <ul>
            <li>Defective or damaged items</li>
            <li>Wrong item sent by mistake</li>
            <li>Orders over $200 USD (or equivalent)</li>
          </ul>

          <h3>Customer-Paid Return Shipping</h3>
          <p>Return shipping costs are customer's responsibility for:</p>
          <ul>
            <li>Change of mind returns on orders under $200</li>
            <li>Size or style preference changes</li>
            <li>Returns to remote locations not covered by our carriers</li>
          </ul>

          <table className="legal-table">
            <thead>
              <tr>
                <th>Region</th>
                <th>Return Shipping Cost</th>
                <th>Transit Time</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>North America</td>
                <td>$12.99</td>
                <td>5-10 business days</td>
              </tr>
              <tr>
                <td>Europe</td>
                <td>€15.99</td>
                <td>7-14 business days</td>
              </tr>
              <tr>
                <td>Australia</td>
                <td>AU$18.99</td>
                <td>10-18 business days</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="legal-section">
          <h2>5. Refund Processing</h2>
          
          <h3>Refund Timeline</h3>
          <ul>
            <li><strong>Inspection:</strong> 1-2 business days after we receive your return</li>
            <li><strong>Approval:</strong> Email notification sent once return is approved</li>
            <li><strong>Processing:</strong> 3-5 business days to process refund</li>
            <li><strong>Bank/Card:</strong> 5-10 business days for funds to appear (varies by institution)</li>
          </ul>

          <h3>Refund Method</h3>
          <p>
            Refunds are processed using the original payment method:
          </p>
          <ul>
            <li>Credit/Debit Cards: Refunded to original card</li>
            <li>PayPal: Refunded to PayPal account</li>
            <li>Bank Transfer: Refunded to original bank account</li>
          </ul>
        </div>

        <div className="legal-section">
          <h2>6. Partial Refunds</h2>
          <p>
            Partial refunds may be issued for:
          </p>
          <ul>
            <li>Items returned with missing accessories (deduction applied)</li>
            <li>Watches with minor damage not affecting functionality</li>
            <li>Items returned outside original packaging</li>
            <li>Returns that show signs of use beyond inspection</li>
          </ul>
          <div className="policy-highlight">
            <p>Partial refund amounts will be communicated before processing.</p>
          </div>
        </div>

        <div className="legal-section">
          <h2>7. Exchanges</h2>
          <p>
            We currently do not offer direct exchanges. To exchange an item:
          </p>
          <ol style={{paddingLeft: "1.5rem"}}>
            <li>Return the original item following our return process</li>
            <li>Place a new order for the desired item</li>
            <li>We'll prioritize processing your new order once return is received</li>
          </ol>
          <p>
            For size or model changes on identical watches, contact customer service 
            for expedited exchange assistance.
          </p>
        </div>

        <div className="legal-section">
          <h2>8. Defective Items</h2>
          <p>
            If you receive a defective watch:
          </p>
          <ul>
            <li>Contact us within 48 hours of delivery</li>
            <li>Provide photos of the defect</li>
            <li>We'll arrange immediate replacement or full refund</li>
            <li>Return shipping is completely free for defective items</li>
            <li>Express replacement shipping at no extra cost</li>
          </ul>
        </div>

        <div className="legal-section">
          <h2>9. Warranty Claims vs Returns</h2>
          
          <h3>Return (30 days)</h3>
          <p>For dissatisfaction, wrong size, or change of mind</p>
          
          <h3>Warranty Claim (12+ months)</h3>
          <p>For manufacturing defects covered under manufacturer warranty</p>
          
          <p>
            Warranty claims are handled directly with the watch manufacturer. 
            We'll provide all necessary documentation and support for warranty processes.
          </p>
        </div>

        <div className="legal-section">
          <h2>10. International Returns</h2>
          <p>
            Additional considerations for international returns:
          </p>
          <ul>
            <li>Customs forms must be completed accurately</li>
            <li>Mark package as "RETURNED GOODS" to avoid duties</li>
            <li>Include copy of original invoice</li>
            <li>Customer responsible for any customs fees on returns</li>
            <li>Extended processing time for customs clearance</li>
          </ul>
        </div>

        <div className="legal-section">
          <h2>11. Lost Return Packages</h2>
          <p>
            If your return package is lost in transit:
          </p>
          <ul>
            <li>Contact us immediately with tracking information</li>
            <li>We'll trace the package with shipping carrier</li>
            <li>Refund processed once loss is confirmed</li>
            <li>Original proof of shipment required</li>
          </ul>
          <div className="policy-highlight">
            <p>Always use trackable shipping methods for returns over $500.</p>
          </div>
        </div>

        <div className="legal-section">
          <h2>12. Cancellation Policy</h2>
          <p>
            Orders can be cancelled:
          </p>
          <ul>
            <li><strong>Before Processing:</strong> Full refund, no fees</li>
            <li><strong>During Processing:</strong> May incur 5% processing fee</li>
            <li><strong>After Shipping:</strong> Must follow return process</li>
          </ul>
          <p>
            To cancel an order, contact customer service immediately with your order number.
          </p>
        </div>

        <div className="legal-section">
          <h2>13. Customer Service</h2>
          <p>
            For return and refund assistance:
          </p>
          <p>
            Email: returns@minute.com<br/>
            Phone: +91-XXX-XXX-XXXX<br/>
            Live Chat: Available on our website<br/>
            Support Hours: Monday-Saturday, 9 AM - 8 PM IST
          </p>
        </div>

        <div className="legal-footer">
          <p><strong>Last Updated:</strong> January 2025</p>
        </div>
      </div>
    </div>
  );
};

export { ReturnRefundPolicy };